<template>
<div class="docInfo" style="font-size: 16px;">
    <div :style="{ height: `${this.screenHeight - 150}px`}" style="overflow-y: scroll;">
       <van-dialog v-model="showDialogVisible" width="100%" show-cancel-button @cancel="handleClose"  :show-confirm-button="false" class="dialog-adverse">
             <iframe ref="qrcode" :src="signUrl" allow="microphone;camera;canvas" v-show="showDialogVisible" class="docframe width-p100" seamless :style="{ height: '500px' }" ></iframe>
        </van-dialog>
    <div class="content" v-for="(item, index) in paginatedQuestions" :index="index" :key="index">
            <vdivider
        :key="item.id"
        :margin="12"
        v-if="item.content && item.content != ' '"
        :style="{ color: '#04A891', borderColor: '#04A891', padding: '0 16px' }"
        >{{getOriginalIndex(index)}}.{{item.content}}</vdivider>
            <!-- 多选 -->
            <vCheckboxGroup v-if="item.select_type_enum==1" v-model="item.answer_value" plain shape="square">
                <vCheckbox checked-color="#04A891" :name="o.value" :key="o.value" v-for="o in item.QuestionOptions" class="checkboxc" shape="square">{{ o.label }}</vCheckbox>
            </vCheckboxGroup>

            <!-- 单选 -->
            <vRadioGroup v-if="item.select_type_enum==2" v-model="item.answer_value">
                <vRadio :name="o.value" :key="o.value" v-for="o in item.QuestionOptions" checked-color="#07c160" style="margin: 10px 0 0 20px;">{{ o.label }}</vRadio>
            </vRadioGroup>

            <!-- 单行文本 -->
            <vcellgroup v-if="item.select_type_enum==3">
                <vfield v-model="item.answer_value" placeholder="请输入"/>
            </vcellgroup>

            <!-- 多行文本 -->
            <vcellgroup v-if="item.select_type_enum==4">
                <vfield type="textarea" v-model="item.answer_value" placeholder="请输入" rows="3" autosize maxlength="100" show-word-limit />
            </vcellgroup>
            <!-- 签名控件 -->
            <div class="questionOptions" v-if="item.select_type_enum==5">
                                <img
                                    class="image_2"
                                    referrerpolicy="no-referrer"
                                    :src="item.sign_picture"
                                    @click="imgclick(item.id)"
                                />

            </div>
        </div>
        <vpagination v-if="this.isPagination" v-model="currentPage" prev-text="<" next-text=">" :show-page-size="4" :page-count="totalPages" :style="paginationStyle" :items-per-page="pageSize" />
    <div class="bottom">
        <vbutton class="btnTrans" type="info" @click="confirm" style="background:#ea5a5a;">确定</vbutton>
    </div>
    </div>
</div>
</template>

<script>
import {
    CellGroup as vcellgroup,
    Cell as vcell,
    PullRefresh as vpullrefresh,
    Stepper as vstepper,
    Field as vfield,
    Tab as vtab,
    Tabs as vtabs,
    NavBar as vnavbar,
    Empty,
    Button as vbutton,
    Dialog,
    Tabbar as vtabbar,
    Search as vsearch,
    TabbarItem as vtabbaritem,
    Icon as vicon,
    Tag as vtag,
    CheckboxGroup as vCheckboxGroup,
    Checkbox as vCheckbox,
    RadioGroup as vRadioGroup,
    Radio as vRadio,
    DatetimePicker as vdatetimepicker,
    Divider as vdivider,
    Pagination as vpagination
} from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
import axios from 'axios'
import Qs from 'qs'
export default {
    name: `DocInfo`,
    components: {
        vcellgroup,
        vpullrefresh,
        vcell,
        vstepper,
        vfield,
        vtab,
        vtabs,
        vnavbar,
        Empty,
        vtabbar,
        vtabbaritem,
        vbutton,
        [Dialog.Component.name]: Dialog.Component,
        vicon,
        vtag,
        vCheckboxGroup,
        vCheckbox,
        vsearch,
        vdatetimepicker,
        vdivider,
        vRadioGroup,
        vRadio,
        vpagination
    },
    props: {
        docId: { type: Number | String, required: true },
        doc: { type: Object, required: true },
        surgeryId: { type: Number | String, required: true },
        isPagination: { type: Boolean, default: false }
    },
    data() {
        window.addEventListener(
            `message`,
            event => {
                if (event.data.action == `ok`) {
                    this.showDialogVisible = false
                    this.CaSignBody(event.data)
                } else {
                    // this.showDialogVisible = false
                }
            },
            false
        )
        return {
            QuestionInfoList: [],
            loading: false,
            showDialogVisible: false,
            docDetail: {
            },
            docBizId: 0,
            docGuid: null,
            docName: null,
            caSignUrl: this.$root.CaSignUrl,
            caImagePath: this.$root.CaImagePath,
            multiQueryProduceConfig: this.$root.MultiQueryProduceConfig == `1`,
            signUrl: null,
            InstanceData: [],
            pageSize: 7,
            currentPage: 1,
            // 可以在这里定义分页控件的位置偏移量
            paginationPosition: {
                top: `150px`,
                bottom: `60px`,
                left: `50%`
            }
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`]),
        // 计算总页数
        totalPages() {
            if (!this.docDetail.Questions || !Array.isArray(this.docDetail.Questions)) {
                return 0
            }
            return Math.ceil(this.docDetail.Questions.length / this.pageSize)
        },
        // 计算当前页的数据
        paginatedQuestions() {
            if (!this.docDetail.Questions || !Array.isArray(this.docDetail.Questions)) {
                return []
            }
            if (!this.isPagination) {
                return this.docDetail.Questions
            }
            let start = (this.currentPage - 1) * this.pageSize
            let end = start + this.pageSize
            return this.docDetail.Questions.slice(start, end)
        },
        paginationStyle() {
            return {
                position: `fixed`,
                bottom: this.paginationPosition.bottom,
                left: this.paginationPosition.left,
                transform: `translateX(-50%)`
            }
        }
    },
    mounted() {
        this.$store.dispatch(`ADD_CURRENTUSER`)
    },
    methods: {
        handleClose() {
            // 处理关闭事件
            this.signUrl = ``
            console.log(`Dialog closed`)
        },
        imgclick(datakey) {
            // 这里需要获取页面的datas，传到ca里面，最好是json字符串
            let { examResult } = this.getData()
            let r = JSON.stringify(examResult)
            let url = `${this.caSignUrl}?app_key=${this.$root.appKey}&ca_token=`
            let caToken = sessionStorage.getItem(`caToken`)
            if (caToken) url = `${url}${caToken}`
            var random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            let rcode = ``
            for (var i = 0; i < 8; i++) {
                // 设置随机数范围,这设置为0 ~ 36
                var index = Math.floor(Math.random() * 9)
                // 字符串拼接 将每次随机的字符 进行拼接
                rcode += random[index]
            }
            // this.docName,最好是文书名称
            this.myaxios
                .post(url, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        biz_id: this.surgeryId + `_` + this.docName + `_` + datakey + `_` + rcode,
                        raw_data: r
                    }
                })
                .then(signUrl => {
                    console.log(signUrl)
                    this.signUrl = signUrl + `&type=${datakey}`
                    this.showDialogVisible = true
                })
        },
        CaSignBody(data) {
            let bizdata = data.data
            let bizs = bizdata.biz_id.split(`_`) // 通过这个获取到底是哪个控件
            if (bizs.length >= 3) {
                let cacontrolId = bizs[2] // 控件Id
                console.log(`this.docDetail.Questions`, this.docDetail.Questions)
                let casign = this.docDetail.Questions && this.docDetail.Questions.find(i => i.id == cacontrolId) || null
                if (casign) {
                    this.$set(casign, `answer_value`, `${bizdata.username}.png`)
                    this.$set(casign, `sign_picture`, `${this.caImagePath}/${bizdata.username}.png`)
                }
            }
        },
        // 获取原始数组中的序号（从1开始）
        getOriginalIndex(paginatedIndex) {
            if (!this.isPagination) {
                return paginatedIndex
            }
            return (this.currentPage - 1) * this.pageSize + paginatedIndex + 1
        },
        loadDocInfo() {
            if (this.doc.is_singleton) {
                // 单例就加载最新的实例
                this.loadInstance()
            } else {
                // 多例就在文书系统创建一个实例
                this.createInstance()
            }
        },
        loadInstance() {
            this.docName = this.$moment().format(`MM-DD HH:mm:ss`)
            let req1 = this.myaxios.get_doc(`wth/QueryTemplateInstances?docid=${this.docId}&deptno=&vid=${this.surgeryId}&operator=米小健`)
            req1.then(doc => {
                if (doc && doc.Status == `SUCCESS`) {
                    if (doc.Content && doc.Content.length > 0) {
                        this.docBizId = doc.Content[0].docbizid
                        this.docGuid = doc.Content[0].docguid
                        // 文书库有保存文书实例内容，加载出来
                        this.loadInstanceValues()
                    } else {
                        // 没有创建一个
                        this.loadDocWth()
                    }
                } else {
                    console.log(doc)
                }
            })
        },
        loadInstanceValues() {
            let that = this
            let info = { producename: `Sys_GetAnesthsiaDoc ${this.docBizId}` }
            if (this.multiQueryProduceConfig) {
                info.validate = false
            }
            let req1 = this.myaxios.post_doc(`Query/MultiQueryProduce`)
            req1.then(data => {
                if (data && data.length > 0) {
                    that.InstanceData = data
                    that.loadLocalDocData(that.InstanceData)
                }
            }).catch(e => console.log(e))
        },
        loadLocalDocData(InstanceData) {
            let that = this
            // InstanceData 是文书数据库存的实例数据，从 InstanceData 中 把结果和手麻控件 一样对应上并把值放到对应控件上，展示
            this.myaxios.get(`/api/MobilePaper/SurgeryMobilePaperValue/GetDocDetail?docId=${this.docId}&surgeryId=${this.surgeryId}`).then((data) => {
                if (data) {
                    data.Questions.forEach(q => {
                        if (q.select_type_enum == 1) {
                            // 多选
                            if (InstanceData && InstanceData.length > 0) {
                                let tagNames = q.QuestionOptions.map(i => i.data_key)
                                let selectTagNames = _.filter(InstanceData, c => {
                                    return _.includes(tagNames, c.Name) && c.Textvalue == `☑`
                                }).map(i => i.Name)
                                console.log(`PC端多选的标签`, tagNames, selectTagNames, q)
                                let selectIds = _.filter(q.QuestionOptions, c => {
                                    return _.includes(selectTagNames, c.data_key)
                                }).map(i => i.id.toString())
                                console.log(`PC端多选的Id值`, selectIds)
                                q.answer_value = selectIds
                            } else {
                                q.answer_value = q.UserQuestionOptionsLogModels && q.UserQuestionOptionsLogModels.length > 0 ? q.UserQuestionOptionsLogModels.map(i => i.dic_mobile_paper_content_options_id.toString()) : []
                            }
                        }
                        if (q.select_type_enum == 2) {
                            // 单选
                            if (InstanceData && InstanceData.length > 0) {
                                // PC端 患者文书已经有文书记录，直接加载PC的文书内容
                                let insValue = InstanceData.find(i => i.Alias == q.alias)
                                if (insValue && insValue.Textvalue == `☑`) {
                                    let selectOption = q.QuestionOptions.find(i => i.data_key == insValue.Name)
                                    q.answer_value = selectOption && selectOption.id.toString()
                                }
                                console.log(`单选题`, insValue, q)
                            } else if (q.UserQuestionOptionsLogModels && q.UserQuestionOptionsLogModels.length > 0) {
                                q.answer_value = q.UserQuestionOptionsLogModels[0].dic_mobile_paper_content_options_id.toString()
                            }
                        }
                        if ((q.select_type_enum == 3 || q.select_type_enum == 4)) {
                            // 填空题
                            if (InstanceData && InstanceData.length > 0) {
                                // PC端 患者文书已经有文书记录，直接加载PC的文书内容
                                let insValue = InstanceData.find(i => i.Name == q.QuestionOptions[0].data_key)
                                console.log(`填空题`, q.QuestionOptions[0].data_key, insValue)
                                q.answer_value = insValue ? insValue.Textvalue : ``
                            } else if (q.UserQuestionOptionsLogModels && q.UserQuestionOptionsLogModels.length > 0) {
                                q.answer_value = q.UserQuestionOptionsLogModels[0].content_options_values
                            }
                            // 值为空时,直接取当前题目的默认值（默认值通过 proc_PreMobilePaperContentOptionValue 获取）
                            q.answer_value = (q.answer_value == `` || q.answer_value == null) ? q.QuestionOptions[0].default_value : q.answer_value
                        }
                        // 签名控件
                        if ((q.select_type_enum == 5)) {
                            if (q.UserQuestionOptionsLogModels && q.UserQuestionOptionsLogModels.length > 0) {
                                q.answer_value = q.UserQuestionOptionsLogModels[0].content_options_values
                                let signpicture = `${this.caImagePath}/${q.UserQuestionOptionsLogModels[0].content_options_values}`
                                that.$set(q, `sign_picture`, signpicture)
                            } else {
                                q.answer_value = ``
                                that.$set(q, `sign_picture`, ``)
                            }
                        }
                    })
                    this.docDetail = data
                    console.log(this.docDetail)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        createInstance() {
            this.docName = this.$moment().format(`MM-DD HH:mm:ss`)
            let req1 = this.myaxios.get_doc(`wth/Instance?1=1&templateid=0&operator=test&dept=acis2020&patientname=&cacertId=&vid=${this.surgeryId}&docid=${this.docId}&docbizid=&docname=${this.docName}&from=190001010000&to=190001010000&uid=${this.surgeryId}&caheno=1&pageStart=1&continuationStatus=0&id1=${this.surgeryId}&id2=1&id3=1&id4=0&client=1`)
            req1.then(doc => {
                if (doc && doc.Status == `SUCCESS`) {
                    this.docBizId = doc.DocBizId
                    if (doc.TargetUrl && doc.TargetUrl.length > 0) {
                        let htmlstr = doc.TargetUrl.split(`/`)
                        let lastElement = htmlstr.slice(-1)[0]
                        this.docGuid = lastElement.split(`.`)[0]
                        this.loadLocalDocData()
                    }
                } else {
                    console.log(`出错了`, doc)
                }
            })
        },
        loadDocWth() {
            let dname = `acis2020_${this.docId}_${this.surgeryId}`
            let time = this.$moment().format(`YYYYMMDDHHmm`)
            let guid = this.generateUUID()
            let req1 = this.myaxios.get_doc(`doc3.ashx/wth?vid=${this.surgeryId}&from=${time}&to=${time}&dept=acis2020&operator=米小健&username=1&catoken=undefined&strategy=UF&guid=${guid}&docid=${this.docId}&docname=${dname}&docbizid=&singleton=true&isShowSendPrintMessage=false`)
            req1.then(doc => {
                if (doc && doc.Status == `SUCCESS`) {
                    this.docBizId = doc.DocBizId
                    if (doc.TargetUrl && doc.TargetUrl.length > 0) {
                        let htmlstr = doc.TargetUrl.split(`/`)
                        let lastElement = htmlstr.slice(-1)[0]
                        this.docGuid = lastElement.split(`.`)[0]
                        this.loadLocalDocData()
                    }
                } else {
                    console.log(doc)
                }
            })
        },
        goToDocList() {
            this.$emit(`goToDocList`)
        },
        getpagedata() {
            console.log(this.docDetail)
            let answers = []
            return answers
        },
        confirm() {
            let that = this
            let { examResult, obj } = that.getData()
            this.myaxios.post(`/api/MobilePaper/SurgeryMobilePaperValue/PostDocInfo`, examResult).then(() => {
                axios.post(`${this.$root.DOCSERVICE_BASE}/Wth/SaveInstanceData`, Qs.stringify(obj), {
                    headers: { 'content-type': `application/x-www-form-urlencoded` }
                })
                this.$message.success(`保存成功`)
                // this.$emit(`afterSaved`)
            }).catch(e => {
                alert(2222)
            })
        },
        getData() {
            let that = this
            console.log(`进入confirm时数据`, this.docDetail.Questions)
            let answers = []
            let obj = {
                docname: that.docName,
                docbizid: that.docBizId,
                docid: that.docId,
                vid: that.surgeryId,
                docguid: that.docGuid,
                oper: `test`,
                saveastemplate: 0
            }
            let j = 0
            this.docDetail.Questions.forEach(question => {
                if (question.select_type_enum == 1) {
                    // 多选
                    question.answer_value.forEach(option => {
                        let optionObj = question.QuestionOptions.find(i => i.id == option)
                        let answer = {
                            question_id: question.id,
                            question_options_id: optionObj && optionObj.id || 0,
                            options_value: optionObj && optionObj.label || ``
                        }
                        answers.push(answer)

                        that.$set(obj, `itemsvalue[${j}][name]`, optionObj && optionObj.data_key || ``)
                        that.$set(obj, `itemsvalue[${j}][alias]`, question.alias)
                        that.$set(obj, `itemsvalue[${j}][textvalue]`, `☑`)
                        that.$set(obj, `itemsvalue[${j}][tableindex]`, null)
                        that.$set(obj, `itemsvalue[${j}][filindex]`, null)
                        j = j + 1
                    })
                }
                if (question.select_type_enum == 2) {
                    // 单选
                    let optionObj = question.QuestionOptions.find(i => i.id == question.answer_value)
                    let answer = {
                        question_id: question.id,
                        question_options_id: optionObj && optionObj.id || 0,
                        options_value: optionObj && optionObj.label || ``
                    }
                    answers.push(answer)

                    that.$set(obj, `itemsvalue[${j}][name]`, optionObj && optionObj.data_key || ``)
                    that.$set(obj, `itemsvalue[${j}][alias]`, question.alias)
                    that.$set(obj, `itemsvalue[${j}][textvalue]`, `☑`)
                    that.$set(obj, `itemsvalue[${j}][tableindex]`, null)
                    that.$set(obj, `itemsvalue[${j}][filindex]`, null)
                    j = j + 1
                }
                if (question.select_type_enum == 3 || question.select_type_enum == 4) {
                    // 填空
                    let answer = {
                        question_id: question.id,
                        question_options_id: question.QuestionOptions && question.QuestionOptions[0].id || 0,
                        options_value: question.answer_value
                    }
                    answers.push(answer)

                    that.$set(obj, `itemsvalue[${j}][name]`, question.QuestionOptions && question.QuestionOptions[0].data_key)
                    that.$set(obj, `itemsvalue[${j}][alias]`, null)
                    that.$set(obj, `itemsvalue[${j}][textvalue]`, question.answer_value || ``)
                    that.$set(obj, `itemsvalue[${j}][tableindex]`, question.QuestionOptions && question.QuestionOptions[0].table_index)
                    that.$set(obj, `itemsvalue[${j}][filindex]`, question.QuestionOptions && question.QuestionOptions[0].fil_index)
                    j = j + 1
                }
                if (question.select_type_enum == 5) {
                    // 签名
                    let answer = {
                        question_id: question.id,
                        question_options_id: question.QuestionOptions && question.QuestionOptions[0].id || 0,
                        options_value: `${question.answer_value}`,
                        sign_picture: `${question.answer_value}`
                    }
                    answers.push(answer)
                    that.$set(obj, `itemsvalue[${j}][name]`, question.QuestionOptions && question.QuestionOptions[0].data_key || ``)
                    that.$set(obj, `itemsvalue[${j}][alias]`, question.alias)
                    that.$set(obj, `itemsvalue[${j}][textvalue]`, `${question.answer_value},${question.QuestionOptions && question.QuestionOptions[0].table_index},${question.QuestionOptions && question.QuestionOptions[0].fil_index}`)
                    that.$set(obj, `itemsvalue[${j}][tableindex]`, null)
                    that.$set(obj, `itemsvalue[${j}][filindex]`, null)
                    j = j + 1
                }
            })

            let examResult = {
                surgery_id: this.surgeryId,
                dic_mobile_paper_id: this.docDetail.id,
                questions: answers
            }
            console.log(`最终保存到手麻系统的数据`, examResult)
            console.log(`最终返回文书系统的数据`, obj)
            return { examResult, obj }
        },
        generateUUID() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            return uuid
        }
    },
    beforeDestroy() {
    },
    watch: {
    }
}
</script>
<style lang="less" scoped>
  @import './mobile_common.css';
 .docInfo {
    // border: unset !important;
    /deep/ .van-icon {
        color: #ffffff !important;
    }
    /deep/ .van-nav-bar__text {
        color: #ffffff !important;
    }
    /deep/ .van-nav-bar__title {
        color: #ffffff !important;
    }
    /deep/ .van-divider {
            margin: 10px 0;
            line-height: 10px;
            font-size: 16px;
    }
    /deep/ .van-hairline--top-bottom {
            border-width: 1px 1px
    }
    /deep/ .van-hairline-unset--top-bottom{
        border-width: 1px 1px
    }
    /deep/ .van-cell-group{
        margin: 0px 10px;
        border:1px solid #04a891;
    }
}
.checkboxc {
    margin: 10px 0 0 20px;
}
.image_2 {
    width: 60px;
    height: 60px;
    margin: 5px 0 6px 0;
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width: 100%;
    .btnTrans {
        flex: 1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}

.van-pagination__next, .van-pagination__prev {
    padding: 0 4px;
    cursor: pointer;
    width: 100px;
}

</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Mobile/DocInfo.vue